import React, { Component } from 'react';

import Slider from 'react-animated-slider';
import { SectionTitle }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const timeline = [
    {
        date: '1996',
        title: 'Início das atividades',
        content: 'Começamos com a fabricação de suportes e mastros para antenas de comunicação, prestando serviços principalmente para a BT, antiga Consat do Brasil.',
        class: 'box-text-right',
    },
    {
        date: '2000',
        title: 'Executando bases não penetrantes',
        content: 'Começamos a executar bases não penetrantes para suportar antenas via satélite, com várias obras realizadas. Por exemplo, na SBT – São Vicente.',
        class: 'box-text-right',
    },
    {
        date: '2003',
        title: '500 toneladas de estrutura metálica',
        content: 'Fornecimento de 500 toneladas de estrutura metálica para o setor de telecomunicações.',
        class: 'box-text-right',
    },
    {
        date: '2005',
        title: 'Projetos especiais ',
        content: 'Projetos especiais de estruturas desenvolvidos para o Grupo CCR.',
        class: 'box-text-right',
    },
    {
        date: '2011',
        title: 'Novos desafios',
        content: 'Novos desafios, reformas e reforço em várias torres da Petrobras, na região Sul do Brasil.',
        class: 'box-text-right',
    },
    {
        date: '2012',
        title: '2.000 toneladas',
        content: 'Fornecimentos de 2.000 toneladas a vários clientes do setor de telecomunicação.',
        class: 'box-text-right',
    },
    {
        date: '2014',
        title: 'Ampliação dos leques',
        content: 'Ampliação dos leques de produtos e serviços, incluindo a importação de equipamentos de rádios e parcerias com a 4RF e Rad - as mais conceituadas empresas de rádios e soluções para telecomunicações no mundo.',
        class: 'box-text-right',
    },
    {
        date: '2016',
        title: 'Certificação ISO 9001',
        content: 'Comemoração dos 20 anos de empresa.',
        class: 'box-text-right',
    },
];

class Timeline extends Component {
    state = { current: 0 };
    render() {
        const { current } = this.state;
        return (
            <section className={ isMobile ? 'home-timeline-mobile' : 'home-timeline'} id="timeline" >
                <div className="container">
                    {SectionTitle({section: 'Linha do Tempo', subtitle:'IDEAL BRASIL', featured: 'Na linha do tempo'})}
                    <div className="timeline">
                        <div className="timeline-dates">
                            <ul>
                            {timeline.map((item, index) => 
                                <li key={index}><a href="#0" className={index <= current ? 'timeline-date active' : 'timeline-date' } style={{ left: 90 * index }}>{item.date}</a></li> 
                            )}                       
                            </ul>
                            <span className={`timeline-bar-${current}`}></span>
                        </div>
                        <Slider 
                            autoplay={5000} 
                            infinite={true} 
                            onSlideChange={event => this.setState({current : event.slideIndex },() => {
                                console.log(this.state.current);
                            }) }
                        >
                            {timeline.map((item, index) => 
                                <div key={index} 
                                    className="animated fadeIn"
                                >
                                    <div className={`box-text animated fadeIn ${item.class}`}>
                                        <div className="bg">
                                            <h4>{item.title}</h4>
                                            { item.content && <p>{item.content}</p> }                                           
                                        </div>                     
                                    </div>                                
                                </div>
                            )}
                        </Slider>
                    </div>
                </div>
            </section>
        )
    }
}

export default Timeline;